<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="createScheduleSetup" (change)="createScheduleSetupChange()" (submit)="createScheduleSetupSubmit()">



        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{"SCHDEDULE_SETUP_CREATE" | translate | titlecase }}</h6>
            </div>
            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">
                <button type="button" class="btn btn-outline-secondary m-2 rounded-0" routerLink="/schedule/schedule-setup"
                    *ngIf="!creating">
                    {{"CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!creating"><i
                        class="fas fa-user-plus"></i>
                    {{"SAVE" | translate | titlecase }}</button>
                <app-loader [show]="creating"></app-loader>
            </div>


        </div>

        <div class="row mt-4">
            <div class="col-12">
                <div class="row bg-white border m-0 py-3 ">
                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"EFFECTIVE_DATE_FROM" | translate | titlecase }}</label>
                                <input type="date" class="form-control" formControlName="effectiveDateFrom">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createScheduleSetup.controls.effectiveDateFrom.touched && createScheduleSetup.controls.effectiveDateFrom.invalid && createScheduleSetup.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"EFFECTIVE_DATE_TO" | translate | titlecase }}</label>
                                <input type="date" class="form-control" formControlName="effectiveDateTo">
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "TIME_SLOT" | translate | titlecase }} [{{ "MIN" | translate | titlecase }}]</label>
                                <input type="number" class="form-control" formControlName="timeSlot">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createScheduleSetup.controls.timeSlot.touched && createScheduleSetup.controls.timeSlot.invalid && createScheduleSetup.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <!-- <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "BREAK_TIME_SLOT" | translate | titlecase }} [{{ "MIN" | translate | titlecase }}]</label>
                                <input type="number" class="form-control" formControlName="breakTimeSlot">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createScheduleSetup.controls.breakTimeSlot.touched && createScheduleSetup.controls.breakTimeSlot.invalid && createScheduleSetup.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div> -->
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"WEEK_STARTS" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="weekStarts">
                                    <option value="" selected>{{"SELECT" | translate | titlecase }}</option>
                                    <option value="SAT">{{"SATURDAY" | translate | titlecase }}</option>
                                    <option value="SUN">{{"SUNDAY" | translate | titlecase }}</option>
                                    <option value="MON">{{"MONDAY" | translate | titlecase }}</option>
                                    <option value="TUE">{{"TUESDAY" | translate | titlecase }}</option>
                                    <option value="WED">{{"WEDNESDAY" | translate | titlecase }}</option>
                                    <option value="THU">{{"THURSDAY" | translate | titlecase }}</option>
                                    <option value="FRI">{{"FRIDAY" | translate | titlecase }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createScheduleSetup.controls.weekStarts.touched && createScheduleSetup.controls.weekStarts.invalid && createScheduleSetup.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "REMARKS" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="remarks">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createScheduleSetup.controls.remarks.touched && createScheduleSetup.controls.remarks.invalid && createScheduleSetup.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"ACTIVE" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="active">
                                    <option value="" selected>{{"SELECT" | translate | titlecase }}</option>
                                    <option value="YES">{{"YES" | translate | titlecase }}</option>
                                    <option value="NO">{{"NO" | translate | titlecase }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createScheduleSetup.controls.active.touched && createScheduleSetup.controls.active.invalid && createScheduleSetup.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-3 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "SAT" | translate | titlecase }}</label>
                                <input type="number" class="form-control" formControlName="saturday">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createScheduleSetup.controls.saturday.touched && createScheduleSetup.controls.saturday.invalid && createScheduleSetup.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-3 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "SUN" | translate | titlecase }}</label>
                                <input type="number" class="form-control" formControlName="sunday">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createScheduleSetup.controls.sunday.touched && createScheduleSetup.controls.sunday.invalid && createScheduleSetup.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-3 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "MON" | translate | titlecase }}</label>
                                <input type="number" class="form-control" formControlName="monday">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createScheduleSetup.controls.monday.touched && createScheduleSetup.controls.monday.invalid && createScheduleSetup.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-3 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "TUE" | translate | titlecase }}</label>
                                <input type="number" class="form-control" formControlName="tuesday">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createScheduleSetup.controls.tuesday.touched && createScheduleSetup.controls.tuesday.invalid && createScheduleSetup.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-3 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "WED" | translate | titlecase }}</label>
                                <input type="number" class="form-control" formControlName="wednesday">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createScheduleSetup.controls.wednesday.touched && createScheduleSetup.controls.wednesday.invalid && createScheduleSetup.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-3 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "THU" | translate | titlecase }}</label>
                                <input type="number" class="form-control" formControlName="thursday">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createScheduleSetup.controls.thursday.touched && createScheduleSetup.controls.thursday.invalid && createScheduleSetup.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-3 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "FRI" | translate | titlecase }}</label>
                                <input type="number" class="form-control" formControlName="friday">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createScheduleSetup.controls.friday.touched && createScheduleSetup.controls.friday.invalid && createScheduleSetup.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<app-loader [attr.show]="showLoader"></app-loader>